export default "__VITE_ASSET__DtW4Z41q__"